import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Container, Typography, Button, Box } from '@material-ui/core';

interface GeneralErrorProps {
  text?: string;
  onRetry?: () => void; // Optional retry function
}

export const GeneralError: React.FC<GeneralErrorProps> = ({
  text,
  onRetry,
}) => {
  return (
    <Container component="main" maxWidth="xs">
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: 32, // equivalent to 4 * 8px
          border: '1px solid #f44336',
          borderRadius: 8, // equivalent to 2 * 4px
          backgroundColor: '#fff3f3',
          boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)',
        }}
      >
        <Typography variant="h4" color="error">
          <FormattedMessage id="error.title" />
        </Typography>
        <Typography variant="body1" style={{ marginTop: 16 }}>
          <FormattedMessage id={text ?? 'error.content'} />
        </Typography>
        {onRetry && (
          <Button
            variant="contained"
            color="secondary" // Note: In Material-UI, 'error' color is not directly available; use 'secondary' or create a custom theme
            style={{ marginTop: 24 }}
            onClick={onRetry}
          >
            <FormattedMessage id="error.retry" defaultMessage="Retry" />
          </Button>
        )}
      </Box>
    </Container>
  );
};
